"use client";

import {
  FieldControl,
  FieldError,
  FieldLabel,
  FieldRoot,
} from "@tillix/ui-atoms/field";
import { Input } from "@tillix/ui-atoms/input";
import {
  Controller,
  type FieldValues,
  type Path,
  useFormContext,
} from "react-hook-form";
import { useT } from "@/features/i18n/hooks/use-t";

export default function EmailInput<TFieldValues extends FieldValues>() {
  const { control } = useFormContext<TFieldValues>();
  const name = "email" as Path<TFieldValues>;
  const { t } = useT("inputs");

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <FieldRoot name={field.name}>
          <FieldLabel>{t("labels.email")}</FieldLabel>

          <FieldControl
            render={(defaultProps) => (
              <Input
                {...defaultProps}
                {...field}
                autoComplete="email"
                placeholder={t("placeholders.email")}
                type="email"
              />
            )}
          />

          <FieldError>
            {fieldState.error ? t("validation.invalidEmail") : undefined}
          </FieldError>
        </FieldRoot>
      )}
    />
  );
}
